const s_utils = {
  "GetOffset": (el) => {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  },
  "OnMutate": (targetNodes, callback) => {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true
    };

    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  },
  "AddItemsToCart": async (items_to_add) => {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  "GetUniqId": () => {
    return "_" + Math.random().toString(36).substr(2, 9);
  },
  "GetCart": async () => {
    return await fetch("/cart.js").then(res => res.json())
  },
  "UpdateCart": (updates) => {
    if (!updates) {
      return;
    }
    
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates })
    });
  },
  "RefreshCart": async () => {
    setTimeout(() => {
      if (window.location.pathname == '/cart') {
        window.location.reload();
      }
      else {
        document.dispatchEvent(new CustomEvent("cart:refresh"))
        document.dispatchEvent(new CustomEvent("variant:add"))  
      }
    }, 0);
  },
  "FormatMoney": (value) => {
    return `${ window.formatMoney ? window.formatMoney(value) : value } ${ Shopify.currency.active !== 'USD' ? Shopify.currency.active : '' }`;
  }
}